import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';

const selectDraftCartState = (state: RootState) => state.draftCart;

const selectDraftCartItems = createSelector(
  selectDraftCartState,
  (draftCart) => draftCart.cartItems
);

const selectDraftCartItemsQuantity = createSelector(
  selectDraftCartState,
  (draftCart) => draftCart.cartItemsQuantity
);

const selectDraftCartItemCollapseStates = createSelector(
  selectDraftCartState,
  (draftCart) => draftCart.cartItemCollapseStates
);

/**
 * HITL-1611 — summed quantities, not a key count.
 *
 * C3's My Cart header band shows how many items are in the cart, and two of the
 * same burger is two items, not one line. `AgentCartCard` counts the same way.
 */
const selectDraftCartItemCount = createSelector(
  selectDraftCartItemsQuantity,
  (quantities) =>
    Object.values(quantities ?? {}).reduce(
      (total, quantity) => total + (quantity || 0),
      0
    )
);

/**
 * Read by C3 (collapse the two-column split back to one) and C6 (enable
 * "Replace order with My Cart" only when there is something to promote).
 * Keyed on items rather than on the count, so a line with a zero quantity
 * still reads as present.
 */
const selectIsDraftCartEmpty = createSelector(
  selectDraftCartItems,
  (cartItems) => Object.keys(cartItems ?? {}).length === 0
);

export {
  selectDraftCartState,
  selectDraftCartItems,
  selectDraftCartItemsQuantity,
  selectDraftCartItemCollapseStates,
  selectDraftCartItemCount,
  selectIsDraftCartEmpty,
};
